<template>
    <div class="flex flex-col gap-4 p-4 md:p-10 md:pt-5 max-w-[718px]">
        <BaseCarousel v-model="activeId" :item-ids="itemIds">
            <template #item-1>
                <p class="body-small mb-4">Just-in-time coaching based on your calendar — prepare and debrief for important conversations right in chat.</p>
                <img :src="CalendarIntegrationExample" alt="calendar integration example" class="w-[632px] mx-auto" />
            </template>
            <template #item-2>
                <p class="body-small mb-4">Collaborate with Nadia on drafting agendas, discussion points, follow-up emails, and more.</p>
                <img :src="CalendarChatExample" alt="chat example" class="w-[632px] mx-auto" />
            </template>
            <template #item-3>
                <p class="body-small mb-4">Smart scheduling for follow ups that fit seamlessly into your calendar availability.</p>
                <img :src="CalendarSchedulingExample" alt="scheduling example" class="w-[632px] mx-auto" />
            </template>
        </BaseCarousel>
        <div class="sticky bottom-0 bg-white pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] flex justify-center">
            <BaseButton
                theme="primary"
                :size="tonalThemeEnabled ? 'sm' : undefined"
                class="w-full md:w-auto md:min-w-52"
                :class="{ 'body-small': !tonalThemeEnabled }"
                @click="$emit('connect')">
                Connect Calendar
            </BaseButton>
        </div>
    </div>
</template>

<script setup>
import CalendarIntegrationExample from "~assets/calendar_feature_carousel_1.png";
import CalendarChatExample from "~assets/calendar_feature_carousel_2.png";
import CalendarSchedulingExample from "~assets/calendar_feature_carousel_3.png";
import BaseCarousel from "~vue/components/BaseCarousel.vue";
import { tonalThemeEnabled } from "~vue/utils/theme";
import { ref } from "vue";

import BaseButton from "../BaseButton.vue";

const itemIds = ["1", "2", "3"];
defineEmits(["connect"]);

// TODO: Remove the legacy calendar branch once the tonal theme becomes the default.
const activeId = ref(null);
</script>
